export default "__VITE_ASSET__DQ8RrKat__"